import i18n from "../../i18n";
import { TranslateDescription } from "../../types/TranslateDescription";

export const userLanguageToDescriptionField = (): string => {
    const lang = i18n.language.toLowerCase();

    if (lang.startsWith('es')) return 'spanish';
    if (lang.startsWith('ca')) return 'catalan';
    if (lang.startsWith('en')) return 'english';
    if (lang.startsWith('fr')) return 'french';
    return 'catalan'; // Por defecto
};


export const languageMap: Record<string, keyof TranslateDescription> = {
  en: "english",
  es: "spanish",
  ca: "catalan",
  fr: "french"
};


export const getTranslatedDescription = (
    description: TranslateDescription | undefined,
    language: string
): string => {
    if (!description) return '-';

    const langMap: Record<string, keyof TranslateDescription> = {
        'ca': 'catalan',
        'es': 'spanish',
        'en': 'english',
        'fr': 'french'
    };

    const key = langMap[language] || 'catalan';
    return description[key] ||
        description.catalan ||
        description.spanish ||
        description.english ||
        description.french ||
        '-';
};